import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-greetings-dashboard',
  templateUrl: './greetings-dashboard.component.html',
  styleUrls: ['./greetings-dashboard.component.scss'],
  standalone: false
})
export class GreetingsDashboardComponent implements OnInit {
  activeTab: 'email' | 'notification' = 'email';

  constructor() { }

  ngOnInit(): void {
  }

  switchTab(tab: 'email' | 'notification'): void {
    this.activeTab = tab;
  }
}
